import { render, staticRenderFns } from "./SendFile.vue?vue&type=template&id=6d3568c6&scoped=true&"
import script from "./SendFile.vue?vue&type=script&lang=js&"
export * from "./SendFile.vue?vue&type=script&lang=js&"
import style0 from "./SendFile.vue?vue&type=style&index=0&id=6d3568c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3568c6",
  null
  
)

export default component.exports